import { render, staticRenderFns } from "./CatalogPlanner.vue?vue&type=template&id=063bf80e"
import script from "./CatalogPlanner.vue?vue&type=script&lang=js"
export * from "./CatalogPlanner.vue?vue&type=script&lang=js"
import style0 from "./CatalogPlanner.vue?vue&type=style&index=0&id=063bf80e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports